import BaseModel from '../core/BaseModel'
export default class FieldSampleModel extends BaseModel {
    constructor() {
        super({ 
                name: "field_sample",
                tableName: 'core_field_sample'
            },
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            name: { 
                name: 'name', 
                type: "String", 
                label: 'Tên trường dữ liệu',
                filter: { type: 'input',match: 'custom'},
                sortable: true
            },
            
            frontend_type: {
                name: 'frontend_type', label: 'Control Type', type: "Selection", class: 'left disabled-select', dataType: 'Label', width: 15, disabled: true
            },

            backend_type: {
                name: 'backend_type', label: 'Kiểu dữ liệu', type: "Selection", class: 'left disabled-select', dataType: 'Label', width: 15, disabled: true
               
            },
            alias: {  name: 'alias', type: "String",  label: 'Định danh'},
            validation: {  name: 'validation', type: "String",  label: 'Ràng buộc'}
        },)
    }

}